import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from 'packages/client/src/app/components/kit/button/button.component';
import { UpdateStore } from './update.store';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { SubscriptionComponent } from '../../../shared/helpers/subscription.component';
import { isOffline } from '../../../../utils/connection.service';

@Component({
    selector: 'app-update',
    templateUrl: './update.component.html',
    styleUrls: ['./update.component.scss'],
    imports: [
        TranslatePipe,
        ButtonComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [UpdateStore],
})
export class UpdateComponent extends SubscriptionComponent {

    protected readonly swUpdate = inject(SwUpdate);

    protected updateAlertDisplayed = signal(false);

    constructor() {
        super();

        this.subs.push(
            this.swUpdate.versionUpdates
                .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
                .subscribe((_) => {
                    this.updateAlertDisplayed.set(true);
                })
            ,
        );
    }

    public async loadNewVersion(): Promise<void> {
        if ('caches' in window) {
            await caches.keys().then(async (names) => {
                await Promise.all(names.map(name => caches.delete(name)));
            });
        }

        window.location.replace(window.location.href);
    }

    protected readonly isOffline = isOffline;
}
